var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7803 22.7601C19.3703 22.7601 19.0303 22.4201 19.0303 22.0101V17.55C19.0303 17.14 19.3703 16.8 19.7803 16.8C20.1903 16.8 20.5303 17.14 20.5303 17.55V22.0101C20.5303 22.4201 20.2003 22.7601 19.7803 22.7601Z",
    fill: "#4F5B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8001 18.2999C18.1701 18.2999 16.8501 16.9799 16.8501 15.3499V13.0799C16.8501 11.4499 18.1701 10.1299 19.8001 10.1299C21.4301 10.1299 22.7501 11.4499 22.7501 13.0799V15.3499C22.7501 16.9799 21.4301 18.2999 19.8001 18.2999ZM19.8001 11.6399C19.0001 11.6399 18.3501 12.2899 18.3501 13.0899V15.3599C18.3501 16.1599 19.0001 16.8099 19.8001 16.8099C20.6001 16.8099 21.2501 16.1599 21.2501 15.3599V13.0899C21.2501 12.2899 20.6001 11.6399 19.8001 11.6399Z",
    fill: "#4F5B92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 22.75C13.8898 22.75 13.5498 22.41 13.5498 22V6.03003C13.5498 4.44003 12.8798 3.76001 11.3198 3.76001H5.08984C3.51984 3.76001 2.83984 4.44003 2.83984 6.03003V22C2.83984 22.41 2.49984 22.75 2.08984 22.75C1.67984 22.75 1.33984 22.41 1.33984 22V6.03003C1.33984 3.60003 2.66984 2.26001 5.08984 2.26001H11.3198C13.7298 2.26001 15.0498 3.60003 15.0498 6.03003V22C15.0498 22.41 14.7098 22.75 14.2998 22.75Z",
    fill: "#4F5B92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7498 9H5.7998C5.3898 9 5.0498 8.66 5.0498 8.25C5.0498 7.84 5.3898 7.5 5.7998 7.5H10.7498C11.1598 7.5 11.4998 7.84 11.4998 8.25C11.4998 8.66 11.1598 9 10.7498 9Z",
    fill: "#4F5B92"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7498 12.75H5.7998C5.3898 12.75 5.0498 12.41 5.0498 12C5.0498 11.59 5.3898 11.25 5.7998 11.25H10.7498C11.1598 11.25 11.4998 11.59 11.4998 12C11.4998 12.41 11.1598 12.75 10.7498 12.75Z",
    fill: "#4F5B92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22.75C7.84 22.75 7.5 22.41 7.5 22V18.25C7.5 17.84 7.84 17.5 8.25 17.5C8.66 17.5 9 17.84 9 18.25V22C9 22.41 8.66 22.75 8.25 22.75Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding4);
export default __webpack_public_path__ + "static/media/building-4.59229f73b814f0d9d5524abdb34d1c03.svg";
export { ForwardRef as ReactComponent };